// Copyright (c) 2024 Deere & Company

import FactoryDuplicatePinPlate from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import t from 'tcomb';

const FactoryDuplicatePinPlates = t.list(FactoryDuplicatePinPlate, 'FactoryDuplicatePinPlates');

export const getDefaultState = () => new FactoryDuplicatePinPlates([]);

export default FactoryDuplicatePinPlates;



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/state/factory-duplicate-pin-plate.js